import { useEffect, useState } from "react";
import { connect, RootStateOrAny } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { Button, Divider, Select, Typography } from "antd";
import { RightOutlined } from "@ant-design/icons";

import notifier from "utils/notifier";
import { ErrorResponse } from "utils/types";
import { getDisplayCompanyId } from "utils/helpers";

import { uploadBatchClaimFiles } from "store/claim/batchReports/actions";
import { getIpaByUser } from "store/app/actions";
import { getHelpCenterLinks } from "store/app/helpCenter/actions";

import { DropzoneSingle } from "components/Common/Dropzone";
import HelpCenterLink from "components/Common/HelpCenterLink";

import styles from "./BatchClaimUpload.module.scss";
import "./index.scss";

const { Title } = Typography;

// NOTE: Will not work properly without AntiVirusHost Server running in conjunction with backend as of 09/27/21

interface BatchClaimsUpload {
  uploadBatchClaimFiles(uploadObject: Object): any;
  isUploading: boolean;
  getIpaByUser(userId: string): any;
  isFetchingIpaByUser: boolean;
  fileTypes: string;
  page: string;
  setPage(page: string): void;
  getHelpCenterLinks(companyId: string, page: string, type: string): any;
}

const BatchClaimsUpload = ({
  fileTypes,
  page,
  setPage,
  ...props
}: BatchClaimsUpload) => {
  const [ipaList, setIpaList] = useState<any[]>([]);
  const [selectedIpa, setSelectedIpa] = useState("");
  const [helpCenter, setHelpCenter] = useState<any>([]);

  useEffect(() => {
    getIpaByUser();
    getHelpCenterLinks();
  }, []);

  const getIpaByUser = () => {
    return props
      .getIpaByUser(sessionStorage.getItem("user_id")!)
      .then((response: any[]) => {
        setIpaList(response);
        setSelectedIpa(response[0].RmiCompanyId);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getHelpCenterLinks = () => {
    props
      .getHelpCenterLinks(
        sessionStorage.getItem("ipaGroup")!,
        "/claims/batch/create",
        "page"
      )
      .then((response: any) => {
        setHelpCenter(response);
      })
      .catch((err: ErrorResponse) => {
        console.log(err?.response?.data?.Message);
      });
  };

  return (
    <div className={styles["batch-claims-page"]}>
      <div className={styles["header-title"]}>
        <Title level={4}>&nbsp;&nbsp;&nbsp;Batch Claims File Upload</Title>
      </div>
      <div className="row ml-1">
        <div className="col-md-12">
          <Select
            className="mt-2"
            placeholder="Select IPA:"
            value={selectedIpa}
            onSelect={(e) => setSelectedIpa(e)}
            style={{ width: "150px" }}
          >
            {ipaList.map((ipa) => (
              <Select.Option key={ipa.RmiCompanyId} value={ipa.RmiCompanyId}>
                {getDisplayCompanyId(ipa.RmiCompanyId)}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div className="col-md-12">
          <div style={{ marginLeft: "auto", float: "right" }} className="mr-3">
            <Button
              className="go-to-button"
              type="primary"
              onClick={() => setPage("test")}
            >
              Go To Submit Test File for New Template <RightOutlined />
            </Button>
            {helpCenter?.length > 0
              ? helpCenter.map((hc: any) => {
                  return (
                    <>
                      <div className={`row ${styles["help-center-box"]}`}>
                        <div className="col-md-24">
                          <HelpCenterLink
                            clickEventId={hc.ClickEventId}
                            linkName={hc.LinkName}
                            pagePath={hc.PagePath}
                            url={hc.Link}
                            companyId={hc.CompanyId}
                          />
                        </div>
                      </div>
                    </>
                  );
                })
              : null}
          </div>
        </div>
      </div>
      <Divider />
      <DropzoneSingle
        fileTypes={fileTypes}
        upload={props.uploadBatchClaimFiles}
        isUploading={props.isUploading}
        page={page}
        selectedIpa={selectedIpa}
      />
    </div>
  );
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isUploading: store.rootReducer.claimBatchReports.isUploadingBatchClaimFiles,
  isFetchingIpaByUser: store.rootReducer.app.isFetchingIpa,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      uploadBatchClaimFiles,
      getIpaByUser,
      getHelpCenterLinks,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(BatchClaimsUpload);
